import Chart from 'chart.js'
Chart.defaults.global.legend.labels.usePointStyle = true
Chart.NewLegend = Chart.Legend.extend({
  afterFit: function() {
    if (this.lineWidths) {
      this.lineWidths = this.lineWidths.map(() => this.width - 12)
      this.height = this.height + 20
    }
  },
})

function createNewLegendAndAttach(chartInstance, legendOpts) {
  var legend = new Chart.NewLegend({
    ctx: chartInstance.chart.ctx,
    options: legendOpts,
    chart: chartInstance,
  })
  if (chartInstance.legend) {
    Chart.layoutService.removeBox(chartInstance, chartInstance.legend)
    delete chartInstance.newLegend
  }
  chartInstance.newLegend = legend
  Chart.layoutService.addBox(chartInstance, legend)
}

// Register the legend plugin
Chart.plugins.register({
  beforeInit: function(chartInstance) {
    var legendOpts = chartInstance.options.legend

    if (legendOpts) {
      createNewLegendAndAttach(chartInstance, legendOpts)
    }
  },
  beforeUpdate: function(chartInstance) {
    var legendOpts = chartInstance.options.legend

    if (legendOpts) {
      legendOpts = Chart.helpers.configMerge(Chart.defaults.global.legend, legendOpts)

      if (chartInstance.newLegend) {
        chartInstance.newLegend.options = legendOpts
      } else {
        createNewLegendAndAttach(chartInstance, legendOpts)
      }
    } else {
      Chart.layoutService.removeBox(chartInstance, chartInstance.newLegend)
      delete chartInstance.newLegend
    }
  },
  afterEvent: function(chartInstance, e) {
    var legend = chartInstance.newLegend
    if (legend) {
      legend.handleEvent(e)
    }
  },
})

function generateChart (chartId, chartType) {
  return {
    render: function (createElement) {
      return createElement(
        'div', {
          style: this.styles,
          class: this.cssClasses,
        },
        [
          createElement(
            'canvas', {
              attrs: {
                id: this.chartId,
                width: this.width,
                height: this.height,
              },
              ref: 'canvas',
            }
          ),
        ]
      )
    },

    props: {
      chartId: {
        default: chartId,
        type: String,
      },
      width: {
        default: 400,
        type: Number,
      },
      height: {
        default: 400,
        type: Number,
      },
      cssClasses: {
        type: String,
        default: '',
      },
      styles: {
        type: Object,
      },
      plugins: {
        type: Array,
        default () {
          return []
        },
      },
    },

    data () {
      return {
        _chart: null,
        _plugins: this.plugins,
      }
    },

    methods: {
      addPlugin (plugin) {
        this.$data._plugins.push(plugin)
      },
      renderChart (data, options) {
        if (this.$data._chart) {
          this.$data._chart.destroy()
        }
        this.$data._chart = new Chart(
          this.$refs.canvas.getContext('2d'), {
            type: chartType,
            data: data,
            options: options,
          }
        )
      },
    },
    beforeDestroy () {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
    },
  }
}

export const Line = generateChart('line-chart', 'line')
export const Bar = generateChart('bar-chart', 'bar')
export const Doughnut = generateChart('doughnut-chart', 'doughnut')
export const Doughnut2 = generateChart('doughnut-chart2', 'doughnut')

export default {
  Line,
  Bar,
  Doughnut,
  Doughnut2,
}



// WEBPACK FOOTER //
// ./src/methods/BaseCharts.js